module.exports = __webpack_public_path__ + "static/media/ph.3a4b9cf6.svg";